import {Form} from "../models/Form";

import {BasicStep} from "../models/steps/BasicStep";
import {ButtonStep} from "../models/steps/ButtonStep";
import {KeyboardStep} from "../models/steps/KeyboardStep";

import store from '../store'

import ThanksRedirectStep from "../components/form/steps/library/fr/thanks_redirect/ThanksRedirectStep";
import HomeStep from "../components/form/steps/library/fr/mobile_home_cashback/HomeStep";
import HomeStepDesk from "../components/form/steps/library/fr/desktop_home_cashback/HomeStep";
import NameGenderStep from "../components/form/steps/library/fr/name_gender/NameStep";
import EmailStep from "../components/form/steps/library/fr/email_no_privacy_cashback/EmailStep";
import AddressStep from "../components/form/steps/library/fr/address/AddressStep";
import PhoneStep from "../components/form/steps/library/fr/phone_optin_cashback/PhoneStep";
import IbanStep from "../components/form/steps/library/fr/iban_cashback/IbanStep";
import PaymentOptinStep from "../components/form/steps/library/fr/payment_optin_satisfaction_cashback/PaymentOptinStep";
import SmsThanksStep from "../components/form/steps/library/fr/sms_thanks/SmsThanksStep";

import MobileFlux from "../views/fr_cashback_2024/MobileView";
import HomeView from "../views/fr_cashback_2024/HomeView";

let sms_service_status = window.sms_service_status==1 ? 'sms' : 'redirect_thanks';

let stepHome

if(window.innerWidth > 768) {
    stepHome = HomeStepDesk
} else stepHome = HomeStep

export default new Form(MobileFlux)
    .firstStep('home')
    .apiEndpoint('/prospect')
    .addSteps({
        home: new BasicStep(stepHome).nextStep('phone').parentComponent(HomeView)
            // .button('Débloquer votre offre exclusive')
            .beforeMount(() => {
                    if (!store.get('form_data/phone')) {
                        store.set('form_data/phone', '+32')
                    }
                })
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        phone: new BasicStep(PhoneStep).nextStep('name_gender').disableBackButton()
            .addFieldsToSend(['phone'])
            .button('Recevoir mon lien d\'activation')
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                store.set('general_data/is_dirty', true)
            }).beforeLeave(() => {
                let phone = store.get('form_data/phone')
                let form_id = store.get('form/resource_form@id')
                return axios.post('/phone', {phone,form_id})
            }),
        name_gender: new ButtonStep(NameGenderStep).nextStep('email')
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .button('Continuer'),
        email: new BasicStep(EmailStep).nextStep('address')
            .button('Continuer')
            .addFieldsToSend(['gender', 'lastname', 'firstname', 'email', 'optin_terms_conditions', 'optin_privacy'])
            .enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        address: new BasicStep(AddressStep).nextStep('iban')
            .addFieldsToSend(['street', 'street_number', 'street_box_number', 'zip_code', 'city'])
            .button('Continuer').enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .beforeMount(() => {
                let phone = store.get('form_data/phone')
                let match_token = store.get('general_data/match_token')
                return axios.put('/phone', {
                    phone,
                    match_token
                })
            }),
        iban: new KeyboardStep(IbanStep).nextStep('payment_optin').button('Confirmer')
            .guard(['iban', 'optin_iban', 'general_data/is_test'])
            .progressBarText(true)
            .beforeMount(() => {
                if (!store.get('form_data/iban')) {
                    store.set('form_data/iban', 'BE')
                }
            })
            .addFieldsToSend(['iban']).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),
        payment_optin: new ButtonStep(PaymentOptinStep).nextStep(sms_service_status)
            .addFieldsToSend(['optin_iban']).enterAnimateDuration(.2)
            .leaveAnimateDuration(.2)
            .progressBarText(true)
            .beforeLeave(() => {
                let match_token = store.get('general_data/match_token')
                let phone = store.get('form_data/phone')
                let form_token = store.get('general_data/form_token')
                let lang = store.get('general_data/lang')
                let country = store.get('general_data/country')
                let is_test = store.get('general_data/is_test')

                store.set('func_data/match_token', match_token);
                store.set('func_data/phone', phone);
                store.set('func_data/form_token', form_token);
                store.set('func_data/lang', lang);
                store.set('func_data/country', country);
                store.set('func_data/is_test', is_test);
                return axios.post('/send_sms_thanks',
                    {
                        phone,
                        match_token,
                        form_token,
                        lang,
                        country,
                        is_test
                    })
            }),
        // phone: new KeyboardStep(PhoneStep).nextStep(sms_service_status).button('Continuer')
        //     .beforeMount(() => {
        //         if (!store.get('form_data/phone') && store.get('form_data/iban') != store.get('func_data/test_iban')) {
        //             store.set('form_data/phone', '+32')
        //         }
        //     })
        //     .addFieldsToSend(['phone'])
        //     .enterAnimateDuration(.2)
        //     .leaveAnimateDuration(.2),
        redirect_thanks: new BasicStep(ThanksRedirectStep).last().disableBackButton(),
        sms: new BasicStep(SmsThanksStep).last().disableBackButton().enterAnimateDuration(.2)
            .leaveAnimateDuration(.2),

    });
